/* template */
<template><div :class="({      'at-didao': atDidao,      'is-android': isAndroid,      'is-ios': isIos,      'is-miniprogram': isMiniprogram,    })" class="didi-mall-select-city"><div class="select-city-wrap"><div class="select-city-header"><mpx-image src="https://ut-static.udache.com/webx/fe-agility-wyc/aeq15uA1CUgiod6QNBP4b.png" class="input-icon-search"></mpx-image><mpx-input type="text" :value="(cityQuery)" :placeholder="($t('city.cityWord'))" @input="onCityChange" class="city-input"/></div><div class="select-current-city"><span class="current-text">{{ $t('city.currentCity') }}</span><div class="current-city-value"><mpx-image src="https://ut-static.udache.com/webx/fe-agility-wyc/MpZuq8UzmsJiSgCzycdbl.png" class="current-city__icon"></mpx-image><span class="current-city__text">{{ currentCity }}</span></div></div></div><div :hidden="(showSuggestList)" class="city-list-wrap"><div class="select-city-list"><city-list :toView="(toView)" @citySelect="onCitySelect" :cityList="(cityList)" :at-didao="(atDidao)"></city-list></div><div class="anchor-list"><mpx-view :class='("letter-item "+(item === selectLetter ? "active": ""))' v-for="(item, index) in (letter_list)" :key="item.index" @touchstart.stop="jumpToWhere(item)" @touchmove.stop="onLetterMove">{{ item }}</mpx-view></div></div><div :hidden="(!showSuggestList)" class="city-list-wrap"><div class="select-city-list"><suggest-city-list :cityList="(searchResList)" @citySelect="onCitySelect"></suggest-city-list></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mdd660a10"}'>
  .didi-mall-select-city
    position fixed
    width 100%
    height 100%
    background #fff
    &.at-didao
      &.is-android
        .select-city-list
          height calc(100vh - 260rpx)
        .anchor-list
          top 246rpx
        .select-city-list
          height calc(100vh - 220rpx - constant(safe-area-inset-top))
          height calc(100vh - 220rpx - env(safe-area-inset-top))
        .anchor-list
          top calc(constant(safe-area-inset-top) + 146rpx)
          top calc(env(safe-area-inset-top) + 146rpx)
    .select-city-header
      position relative
      display flex
      flex 1
      align-items center
      height 110rpx
      white-space nowrap
      box-sizing border-box
      font-size 28rpx
      padding 0 20rpx
      background #fff
      .input-icon-search
        height 28rpx
        width 28rpx
        font-size 36rpx
        color #999
        position absolute
        left 46rpx
      .city-input
        border none
        background #F8FAFD
        border-radius 16rpx
        height 88rpx
        width 100%
        font-size 28rpx
        font-weight 400
        padding 20rpx 62rpx
        line-height 48rpx
        outline none
        box-sizing border-box
    .select-current-city
      position relative
      height 110rpx
      display flex
      align-items left
      flex-direction column
      padding-left 38rpx
      padding-top 40rpx
      padding-bottom 43rpx
      font-size 28rpx
      background #fff
      color #333
      .current-text
        font-size 28rpx
        font-weight 500
      .current-city-value
        display inline-flex
        max-width max-content
        padding 16rpx 35rpx
        background #F5F6FA
        border-radius 7rpx
        align-items center
        justify-content center
        height 65rpx
        margin-top 16rpx
        .current-city__icon
          display inline-block
          height 20rpx
          width 20rpx
        .current-city__text
          display inline-block
          font-size 24rpx
          margin-left 6rpx
    .city-list-wrap
      width 100%
      .select-city-list
        width 100%
        height calc(100vh - 260rpx) // 头部和当前城市高度
        position relative
      .anchor-list
        position relative
        z-index 2
        font-family Helvetica
        position fixed
        top 32%
        right 0
        width 70rpx
        font-size 24rpx
        text-align center
        line-height 34rpx
        color #666
        .active
          font-weight bold
          color #eb6f36
    .select-city-wrap
      position relative
      transform translateZ(2rpx)
      z-index 1
      width 100%
      height 310rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

  import mpx,{ createComponent } from '@mpxjs/core'
  import { is } from '@didi/webx-js'

  createComponent({
    properties: {
      cityList: Array,
      currentCity: String,
      atDidao: Boolean,
      isNewVersion: {
        type: Boolean,
        value: false,
      },
    },
    data: {
      toView: '',
      cityName: '',
      letter_list: [
        'A', 'B', 'C', 'D', 'E', 'F', 'G',
        'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'P', 'Q', 'R', 'S', 'T', 'U', 'W',
        'X', 'Y', 'Z',
      ],
      dataList: [], // 城市查询结果返回
      cityQuery: '', // 城市查询信息
      selectLetter: 'A',
      isAndroid: is('android'),
      isIos: is('ios'),
      isMiniprogram: is('miniprogram'),
    },
    computed: {
      showSuggestList: function() {
        return this.cityQuery !== ''
      },
      zhCityList: function() {
        const uniqueCity = []
        const zhlist = this.cityList.reduce((prev, current) => {
          return prev.concat(current.cities)
        }, [])
        zhlist.forEach(c1 => {
          if (!uniqueCity.find(c2 => c2.id === c1.id)) {
            uniqueCity.push(c1)
          }
        })
        return uniqueCity
      },
      searchResList: function() {
          // const list = this.cityList
          let resList = []
          if (this.cityQuery) {
            // 判断是否包含中文
            if (/.*[\u4e00-\u9fa5]+.*/.test(this.cityQuery)) {
              // 匹配中文
              const filterList = this.zhCityList.filter(item => {
                return item.name.indexOf(this.cityQuery) > -1
              })
              let filterStrList = filterList.map(item => JSON.stringify(item))
              filterStrList = Array.from(new Set(filterStrList))
              return filterStrList.map(item => JSON.parse(item))
            }

            // 拼音搜索优化
            const query = this.cityQuery.toLowerCase()
            resList = this.zhCityList.filter(item => {
              // 转换为小写进行比较
              const cityPinyin = item.en.toLowerCase()
              return cityPinyin.indexOf(query) > -1
            })

            return resList
          }
          return []
      },
    },
    ready() {
      this.initIntersectionObserver()
    },
    detached() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    },
    methods: {
      async initIntersectionObserver() {
        // 先获取滚动容器元素
        const scrollContainer = document.getElementsByClassName('select-city-list')[0]

        // 先清理之前的观察器
        if (this.observer) {
          this.observer.disconnect()
        }
        // 创建观察器实例
        const observer = new IntersectionObserver(entries => {
          entries?.forEach(entry => {
            // 只处理在视口内的元素
            if (entry.isIntersecting) {
                this.selectLetter = entry.target.id === 'star' ? '*' : entry.target.id
            }
          })
        }, {
          root: scrollContainer,
          threshold: [ 0.8 ],
          rootMargin: '0px 0px -50% 0px', // 调整观察的边距
        })
         // 等待目标元素出现
        const getTargets = () => {
          return new Promise(resolve => {
            const targets = document.getElementsByClassName('didi-mall-city-list-block_name')
            if (targets && targets.length > 0) {
              resolve(targets)
            } else {
              setTimeout(() => resolve(getTargets()), 100)
            }
          })
        }
        // 等待获取目标元素
        const targets = await getTargets()

        for (let i = 0; i < targets.length; i++) {
          observer.observe(targets[i])
        }
        // 保存observer实例用于清理
        this.observer = observer
      },
      onCityChange(e) {
        this.cityQuery = e.detail?.value
      },
      onCitySelect(e) {
        this.triggerEvent('changeCity', e.detail)
      },
      jumpToWhere(item) {
        if(this.cityList.find(e => e.letter === item)){
          if (this.selectLetter === item) {
          return
        }
          this.selectLetter = item
          this.toView = item !== '*' ? item : 'star'
        }
      },
      onLetterMove(e) {
        // 获取当前触摸点的位置
        const touch = e.touches[0]
        // 获取所有字母元素
        const query = mpx.createSelectorQuery()
        query?.selectAll('.letter-item').boundingClientRect(rects => {
          rects?.forEach(rect => {
            // 判断触摸点是否在当前字母元素区域内
            if (touch.clientY >= rect.top && touch.clientY <= rect.bottom) {
              const index = rects.indexOf(rect)
              if (index >= 0 && this.letter_list[index] !== this.selectLetter) {
                this.jumpToWhere(this.letter_list[index])
              }
            }
          })
        }).exec()
      },
    },
  })


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "indexdd660a10",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'suggest-city-list':getComponent(require("./suggestlist/index.mpx?component=true&componentId=index216564cb")),'city-list':getComponent(require("./citylist/index.mpx?component=true&componentId=index7dbcda14")),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true }),'mpx-input':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?component=true"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
